<template>
  <EmdFormGroup
    :label="$t('founding-date')"
    :state="getState($v.recipient.founding_date)"
    :feedbacks="feedbacks($v.recipient.founding_date)"
  >
    <EmdInput
      @input="updateField"
      v-model="founding_date"
      placeholder="DD/MM/AAAA"
      name="founding_date"
      :readonly="disabled"
      :disabled="disabled"
    />
  </EmdFormGroup>
</template>

<script>
import { EmdFormGroup, EmdInput } from 'emerald-vue/src/components'
import { getState, feedbacks } from '@/utils/form.utils'
import { corporationUser } from '../validations'
export default {
  name: 'FoundingInput',
  components: {
    EmdFormGroup,
    EmdInput
  },
  data: () => ({
    getState,
    feedbacks,
    founding_date: ''
  }),
  props: {
    recipient: {
      type: Object
    },
    disabled: {
      type: Boolean
    }
  },
  validations () {
    return { recipient: corporationUser }
  },
  methods: {
    updateField (value) {
      this.$v.recipient.founding_date.$touch()

      const dateParts = value.split('/').reverse()
      const year = dateParts[0]
      const month = dateParts[1]
      const day = dateParts[2]
      this.recipient.founding_date = `${year}-${month}-${day}`
    }
  },
  mounted () {
    this.founding_date = this.recipient.founding_date
  }
}
</script>
<i18n>
  {
    "pt-BR": {
      "founding-date": "Data de fundação"
    },
    "en-US": {
      "founding-date": "Founding date"
    }
  }
</i18n>
